import { render, staticRenderFns } from "./CommentStickerPlayer.vue?vue&type=template&id=3ccbad50&scoped=true"
import script from "./CommentStickerPlayer.vue?vue&type=script&lang=ts"
export * from "./CommentStickerPlayer.vue?vue&type=script&lang=ts"
import style0 from "./CommentStickerPlayer.vue?vue&type=style&index=0&id=3ccbad50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccbad50",
  null
  
)

export default component.exports